import * as yup from 'yup';

import {
  emailVerification,
  validateGiftRecipient,
} from '../../utils/backend-api/groupSubscription';

export default function subscriptionEmailsValidation() {
  return yup
    .array()
    .min(1, "Please enter recipients' emails separated by spaces or comma")
    .test('email validation', 'Please enter valid email addresses', async (emails) => {
      for (let i = 0; i < emails.length; i++) {
        const res = await emailVerification({
          email: emails[i].value,
        });
        if (!res.success) {
          return false;
        }
      }
      return true;
    })
    .test('validate', 'User is already a subscriber', async (emails) => {
      for (let i = 0; i < emails.length; i++) {
        const res = await validateGiftRecipient({
          email: emails[i].value,
        });
        if (!res.success) {
          return false;
        }
      }
      return true;
    });
}
